// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IndySoft Enterprise API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateEquipmentFromTemplateCommand } from '../models';
// @ts-ignore
import type { EquipmentCertificateViewModel } from '../models';
// @ts-ignore
import type { EquipmentMetadataViewModel } from '../models';
// @ts-ignore
import type { EquipmentTaxonomyPagedViewModel } from '../models';
// @ts-ignore
import type { EquipmentViewModel } from '../models';
// @ts-ignore
import type { GetEmployeeCheckedOutEquipmentViewModel } from '../models';
// @ts-ignore
import type { InventoryInformationViewModel } from '../models';
// @ts-ignore
import type { LocationStorageType } from '../models';
// @ts-ignore
import type { TaxonomyNodeViewModel } from '../models';
// @ts-ignore
import type { ValidateEquipmentIdForCreationCommand } from '../models';
// @ts-ignore
import type { ValidateEquipmentIdForCreationCommandHandlerResult } from '../models';
/**
 * EquipmentApi - axios parameter creator
 * @export
 */
export const EquipmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the latest calibration certificate blob (stored in Local Database) for an equipment by Company Name and Asset ID.
         * @param {string} companyName 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdCertificateDownloadGet: async (companyName: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdCertificateDownloadGet', 'companyName', companyName)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdCertificateDownloadGet', 'id', id)
            const localVarPath = `/api/equipment/{companyName}/{id}/certificate/download`
                .replace(`{${"companyName"}}`, encodeURIComponent(String(companyName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the latest calibration certificate metadata for an equipment by Company Name and Asset ID.
         * @param {string} companyName 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdCertificateGet: async (companyName: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdCertificateGet', 'companyName', companyName)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdCertificateGet', 'id', id)
            const localVarPath = `/api/equipment/{companyName}/{id}/certificate`
                .replace(`{${"companyName"}}`, encodeURIComponent(String(companyName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets an equipment by Company Name and Asset ID.
         * @param {string} companyName The Company Name to use.
         * @param {string} id The ID field of the asset. **Note:** Do not confuse with Global ID. This ID is &#x60;GAGES.GAGE_SN&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdGet: async (companyName: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdGet', 'companyName', companyName)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEquipmentCompanyNameIdGet', 'id', id)
            const localVarPath = `/api/equipment/{companyName}/{id}`
                .replace(`{${"companyName"}}`, encodeURIComponent(String(companyName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get equipment created metadata.
         * @param {string} [templateName] The name of the template to create metadata from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCreateMetadataGet: async (templateName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/equipment/create-metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (templateName !== undefined) {
                localVarQueryParameter['templateName'] = templateName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all records with quantities that an equipment currently has checked out.  Optionally filters by location to verify if equipment was checked out from a specific location or its sub-locations.
         * @param {string} globalId The Global ID of the equipment.
         * @param {string} [locationId] Optional. The Location ID to filter equipment checked out from this location or its sub-locations (at or under).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGlobalIdCheckOutRecordsGet: async (globalId: string, locationId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'globalId' is not null or undefined
            assertParamExists('apiEquipmentGlobalIdCheckOutRecordsGet', 'globalId', globalId)
            const localVarPath = `/api/equipment/{globalId}/check-out-records`
                .replace(`{${"globalId"}}`, encodeURIComponent(String(globalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finds the Unique or Inventory based asset, by its Global ID.  Then also retrieve some inventory/location information, by its Location From.
         * @param {string} globalId The Global ID of an equipment.
         * @param {string} [locationId] The Location ID of an equipment. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGlobalIdInventoryInformationGet: async (globalId: string, locationId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'globalId' is not null or undefined
            assertParamExists('apiEquipmentGlobalIdInventoryInformationGet', 'globalId', globalId)
            const localVarPath = `/api/equipment/{globalId}/inventory-information`
                .replace(`{${"globalId"}}`, encodeURIComponent(String(globalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finds the leader kit of an equipment if it belongs to a kit, by its Global ID.
         * @param {string} globalId The Global ID of an equipment that belongs to a kit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGlobalIdLeaderKitGet: async (globalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'globalId' is not null or undefined
            assertParamExists('apiEquipmentGlobalIdLeaderKitGet', 'globalId', globalId)
            const localVarPath = `/api/equipment/{globalId}/leader-kit`
                .replace(`{${"globalId"}}`, encodeURIComponent(String(globalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the Taxonomy Hierarchy for the Taxonomy Node associated with an Equipment.
         * @param {string} globalId The ID of the equipment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGlobalIdTaxonomyTreeGet: async (globalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'globalId' is not null or undefined
            assertParamExists('apiEquipmentGlobalIdTaxonomyTreeGet', 'globalId', globalId)
            const localVarPath = `/api/equipment/{globalId}/taxonomy-tree`
                .replace(`{${"globalId"}}`, encodeURIComponent(String(globalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new equipment asset from a template.  Fields marked as template-linked cannot be overridden by the user.  Use the GET /create-metadata endpoint to retrieve field definitions and template links before creating.
         * @param {CreateEquipmentFromTemplateCommand} [createEquipmentFromTemplateCommand] The command containing template name and asset information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentPost: async (createEquipmentFromTemplateCommand?: CreateEquipmentFromTemplateCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/equipment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEquipmentFromTemplateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finds equipment based on a Taxonomy Node ID and optionally a location.
         * @param {string} [taxonomyNodeId] The ID of the Taxonomy Node to relate in the search.
         * @param {string} [locationId] The location tree location ID where the equipment should be.
         * @param {LocationStorageType} [locationType] The location to pick from in the equipment. (Defaults to Current)
         * @param {boolean} [excludeItemsInKits] Excludes unique assets that are already in kits.  Defaults to false.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentSearchByTaxonomyLocationGet: async (taxonomyNodeId?: string, locationId?: string, locationType?: LocationStorageType, excludeItemsInKits?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/equipment/search/by-taxonomy-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (taxonomyNodeId !== undefined) {
                localVarQueryParameter['TaxonomyNodeId'] = taxonomyNodeId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['LocationId'] = locationId;
            }

            if (locationType !== undefined) {
                localVarQueryParameter['LocationType'] = locationType;
            }

            if (excludeItemsInKits !== undefined) {
                localVarQueryParameter['ExcludeItemsInKits'] = excludeItemsInKits;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checks whether the equipment can be created given a Company Name and Equipment Id.  Follows the business rules for system-wide settings \"Use unique Equipment Ids across all companies\".
         * @param {ValidateEquipmentIdForCreationCommand} [validateEquipmentIdForCreationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentValidateIdForCreationPost: async (validateEquipmentIdForCreationCommand?: ValidateEquipmentIdForCreationCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/equipment/validate-id-for-creation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateEquipmentIdForCreationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EquipmentApi - functional programming interface
 * @export
 */
export const EquipmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EquipmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets the latest calibration certificate blob (stored in Local Database) for an equipment by Company Name and Asset ID.
         * @param {string} companyName 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentCompanyNameIdCertificateDownloadGet(companyName: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentCompanyNameIdCertificateDownloadGet(companyName, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentCompanyNameIdCertificateDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the latest calibration certificate metadata for an equipment by Company Name and Asset ID.
         * @param {string} companyName 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentCompanyNameIdCertificateGet(companyName: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquipmentCertificateViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentCompanyNameIdCertificateGet(companyName, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentCompanyNameIdCertificateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets an equipment by Company Name and Asset ID.
         * @param {string} companyName The Company Name to use.
         * @param {string} id The ID field of the asset. **Note:** Do not confuse with Global ID. This ID is &#x60;GAGES.GAGE_SN&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentCompanyNameIdGet(companyName: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquipmentViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentCompanyNameIdGet(companyName, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentCompanyNameIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get equipment created metadata.
         * @param {string} [templateName] The name of the template to create metadata from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentCreateMetadataGet(templateName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquipmentMetadataViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentCreateMetadataGet(templateName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentCreateMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all records with quantities that an equipment currently has checked out.  Optionally filters by location to verify if equipment was checked out from a specific location or its sub-locations.
         * @param {string} globalId The Global ID of the equipment.
         * @param {string} [locationId] Optional. The Location ID to filter equipment checked out from this location or its sub-locations (at or under).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentGlobalIdCheckOutRecordsGet(globalId: string, locationId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmployeeCheckedOutEquipmentViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentGlobalIdCheckOutRecordsGet(globalId, locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentGlobalIdCheckOutRecordsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Finds the Unique or Inventory based asset, by its Global ID.  Then also retrieve some inventory/location information, by its Location From.
         * @param {string} globalId The Global ID of an equipment.
         * @param {string} [locationId] The Location ID of an equipment. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentGlobalIdInventoryInformationGet(globalId: string, locationId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryInformationViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentGlobalIdInventoryInformationGet(globalId, locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentGlobalIdInventoryInformationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Finds the leader kit of an equipment if it belongs to a kit, by its Global ID.
         * @param {string} globalId The Global ID of an equipment that belongs to a kit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentGlobalIdLeaderKitGet(globalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentGlobalIdLeaderKitGet(globalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentGlobalIdLeaderKitGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the Taxonomy Hierarchy for the Taxonomy Node associated with an Equipment.
         * @param {string} globalId The ID of the equipment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentGlobalIdTaxonomyTreeGet(globalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxonomyNodeViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentGlobalIdTaxonomyTreeGet(globalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentGlobalIdTaxonomyTreeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new equipment asset from a template.  Fields marked as template-linked cannot be overridden by the user.  Use the GET /create-metadata endpoint to retrieve field definitions and template links before creating.
         * @param {CreateEquipmentFromTemplateCommand} [createEquipmentFromTemplateCommand] The command containing template name and asset information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentPost(createEquipmentFromTemplateCommand?: CreateEquipmentFromTemplateCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquipmentViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentPost(createEquipmentFromTemplateCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Finds equipment based on a Taxonomy Node ID and optionally a location.
         * @param {string} [taxonomyNodeId] The ID of the Taxonomy Node to relate in the search.
         * @param {string} [locationId] The location tree location ID where the equipment should be.
         * @param {LocationStorageType} [locationType] The location to pick from in the equipment. (Defaults to Current)
         * @param {boolean} [excludeItemsInKits] Excludes unique assets that are already in kits.  Defaults to false.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentSearchByTaxonomyLocationGet(taxonomyNodeId?: string, locationId?: string, locationType?: LocationStorageType, excludeItemsInKits?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquipmentTaxonomyPagedViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentSearchByTaxonomyLocationGet(taxonomyNodeId, locationId, locationType, excludeItemsInKits, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentSearchByTaxonomyLocationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Checks whether the equipment can be created given a Company Name and Equipment Id.  Follows the business rules for system-wide settings \"Use unique Equipment Ids across all companies\".
         * @param {ValidateEquipmentIdForCreationCommand} [validateEquipmentIdForCreationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEquipmentValidateIdForCreationPost(validateEquipmentIdForCreationCommand?: ValidateEquipmentIdForCreationCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateEquipmentIdForCreationCommandHandlerResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEquipmentValidateIdForCreationPost(validateEquipmentIdForCreationCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentApi.apiEquipmentValidateIdForCreationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EquipmentApi - factory interface
 * @export
 */
export const EquipmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EquipmentApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets the latest calibration certificate blob (stored in Local Database) for an equipment by Company Name and Asset ID.
         * @param {EquipmentApiApiEquipmentCompanyNameIdCertificateDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdCertificateDownloadGet(requestParameters: EquipmentApiApiEquipmentCompanyNameIdCertificateDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEquipmentCompanyNameIdCertificateDownloadGet(requestParameters.companyName, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the latest calibration certificate metadata for an equipment by Company Name and Asset ID.
         * @param {EquipmentApiApiEquipmentCompanyNameIdCertificateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdCertificateGet(requestParameters: EquipmentApiApiEquipmentCompanyNameIdCertificateGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentCertificateViewModel> {
            return localVarFp.apiEquipmentCompanyNameIdCertificateGet(requestParameters.companyName, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets an equipment by Company Name and Asset ID.
         * @param {EquipmentApiApiEquipmentCompanyNameIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCompanyNameIdGet(requestParameters: EquipmentApiApiEquipmentCompanyNameIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentViewModel> {
            return localVarFp.apiEquipmentCompanyNameIdGet(requestParameters.companyName, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get equipment created metadata.
         * @param {EquipmentApiApiEquipmentCreateMetadataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentCreateMetadataGet(requestParameters: EquipmentApiApiEquipmentCreateMetadataGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentMetadataViewModel> {
            return localVarFp.apiEquipmentCreateMetadataGet(requestParameters.templateName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all records with quantities that an equipment currently has checked out.  Optionally filters by location to verify if equipment was checked out from a specific location or its sub-locations.
         * @param {EquipmentApiApiEquipmentGlobalIdCheckOutRecordsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGlobalIdCheckOutRecordsGet(requestParameters: EquipmentApiApiEquipmentGlobalIdCheckOutRecordsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEmployeeCheckedOutEquipmentViewModel> {
            return localVarFp.apiEquipmentGlobalIdCheckOutRecordsGet(requestParameters.globalId, requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finds the Unique or Inventory based asset, by its Global ID.  Then also retrieve some inventory/location information, by its Location From.
         * @param {EquipmentApiApiEquipmentGlobalIdInventoryInformationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGlobalIdInventoryInformationGet(requestParameters: EquipmentApiApiEquipmentGlobalIdInventoryInformationGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<InventoryInformationViewModel> {
            return localVarFp.apiEquipmentGlobalIdInventoryInformationGet(requestParameters.globalId, requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finds the leader kit of an equipment if it belongs to a kit, by its Global ID.
         * @param {EquipmentApiApiEquipmentGlobalIdLeaderKitGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGlobalIdLeaderKitGet(requestParameters: EquipmentApiApiEquipmentGlobalIdLeaderKitGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiEquipmentGlobalIdLeaderKitGet(requestParameters.globalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the Taxonomy Hierarchy for the Taxonomy Node associated with an Equipment.
         * @param {EquipmentApiApiEquipmentGlobalIdTaxonomyTreeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGlobalIdTaxonomyTreeGet(requestParameters: EquipmentApiApiEquipmentGlobalIdTaxonomyTreeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxonomyNodeViewModel> {
            return localVarFp.apiEquipmentGlobalIdTaxonomyTreeGet(requestParameters.globalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new equipment asset from a template.  Fields marked as template-linked cannot be overridden by the user.  Use the GET /create-metadata endpoint to retrieve field definitions and template links before creating.
         * @param {EquipmentApiApiEquipmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentPost(requestParameters: EquipmentApiApiEquipmentPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentViewModel> {
            return localVarFp.apiEquipmentPost(requestParameters.createEquipmentFromTemplateCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finds equipment based on a Taxonomy Node ID and optionally a location.
         * @param {EquipmentApiApiEquipmentSearchByTaxonomyLocationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentSearchByTaxonomyLocationGet(requestParameters: EquipmentApiApiEquipmentSearchByTaxonomyLocationGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentTaxonomyPagedViewModel> {
            return localVarFp.apiEquipmentSearchByTaxonomyLocationGet(requestParameters.taxonomyNodeId, requestParameters.locationId, requestParameters.locationType, requestParameters.excludeItemsInKits, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checks whether the equipment can be created given a Company Name and Equipment Id.  Follows the business rules for system-wide settings \"Use unique Equipment Ids across all companies\".
         * @param {EquipmentApiApiEquipmentValidateIdForCreationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentValidateIdForCreationPost(requestParameters: EquipmentApiApiEquipmentValidateIdForCreationPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ValidateEquipmentIdForCreationCommandHandlerResult> {
            return localVarFp.apiEquipmentValidateIdForCreationPost(requestParameters.validateEquipmentIdForCreationCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EquipmentApi - interface
 * @export
 * @interface EquipmentApi
 */
export interface EquipmentApiInterface {
    /**
     * 
     * @summary Gets the latest calibration certificate blob (stored in Local Database) for an equipment by Company Name and Asset ID.
     * @param {EquipmentApiApiEquipmentCompanyNameIdCertificateDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentCompanyNameIdCertificateDownloadGet(requestParameters: EquipmentApiApiEquipmentCompanyNameIdCertificateDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Gets the latest calibration certificate metadata for an equipment by Company Name and Asset ID.
     * @param {EquipmentApiApiEquipmentCompanyNameIdCertificateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentCompanyNameIdCertificateGet(requestParameters: EquipmentApiApiEquipmentCompanyNameIdCertificateGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentCertificateViewModel>;

    /**
     * 
     * @summary Gets an equipment by Company Name and Asset ID.
     * @param {EquipmentApiApiEquipmentCompanyNameIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentCompanyNameIdGet(requestParameters: EquipmentApiApiEquipmentCompanyNameIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentViewModel>;

    /**
     * 
     * @summary Get equipment created metadata.
     * @param {EquipmentApiApiEquipmentCreateMetadataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentCreateMetadataGet(requestParameters?: EquipmentApiApiEquipmentCreateMetadataGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentMetadataViewModel>;

    /**
     * 
     * @summary Retrieves all records with quantities that an equipment currently has checked out.  Optionally filters by location to verify if equipment was checked out from a specific location or its sub-locations.
     * @param {EquipmentApiApiEquipmentGlobalIdCheckOutRecordsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentGlobalIdCheckOutRecordsGet(requestParameters: EquipmentApiApiEquipmentGlobalIdCheckOutRecordsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEmployeeCheckedOutEquipmentViewModel>;

    /**
     * 
     * @summary Finds the Unique or Inventory based asset, by its Global ID.  Then also retrieve some inventory/location information, by its Location From.
     * @param {EquipmentApiApiEquipmentGlobalIdInventoryInformationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentGlobalIdInventoryInformationGet(requestParameters: EquipmentApiApiEquipmentGlobalIdInventoryInformationGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<InventoryInformationViewModel>;

    /**
     * 
     * @summary Finds the leader kit of an equipment if it belongs to a kit, by its Global ID.
     * @param {EquipmentApiApiEquipmentGlobalIdLeaderKitGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentGlobalIdLeaderKitGet(requestParameters: EquipmentApiApiEquipmentGlobalIdLeaderKitGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Gets the Taxonomy Hierarchy for the Taxonomy Node associated with an Equipment.
     * @param {EquipmentApiApiEquipmentGlobalIdTaxonomyTreeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentGlobalIdTaxonomyTreeGet(requestParameters: EquipmentApiApiEquipmentGlobalIdTaxonomyTreeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxonomyNodeViewModel>;

    /**
     * 
     * @summary Creates a new equipment asset from a template.  Fields marked as template-linked cannot be overridden by the user.  Use the GET /create-metadata endpoint to retrieve field definitions and template links before creating.
     * @param {EquipmentApiApiEquipmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentPost(requestParameters?: EquipmentApiApiEquipmentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentViewModel>;

    /**
     * 
     * @summary Finds equipment based on a Taxonomy Node ID and optionally a location.
     * @param {EquipmentApiApiEquipmentSearchByTaxonomyLocationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentSearchByTaxonomyLocationGet(requestParameters?: EquipmentApiApiEquipmentSearchByTaxonomyLocationGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentTaxonomyPagedViewModel>;

    /**
     * 
     * @summary Checks whether the equipment can be created given a Company Name and Equipment Id.  Follows the business rules for system-wide settings \"Use unique Equipment Ids across all companies\".
     * @param {EquipmentApiApiEquipmentValidateIdForCreationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApiInterface
     */
    apiEquipmentValidateIdForCreationPost(requestParameters?: EquipmentApiApiEquipmentValidateIdForCreationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateEquipmentIdForCreationCommandHandlerResult>;

}

/**
 * Request parameters for apiEquipmentCompanyNameIdCertificateDownloadGet operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentCompanyNameIdCertificateDownloadGetRequest
 */
export interface EquipmentApiApiEquipmentCompanyNameIdCertificateDownloadGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EquipmentApiApiEquipmentCompanyNameIdCertificateDownloadGet
     */
    readonly companyName: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentApiApiEquipmentCompanyNameIdCertificateDownloadGet
     */
    readonly id: string
}

/**
 * Request parameters for apiEquipmentCompanyNameIdCertificateGet operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentCompanyNameIdCertificateGetRequest
 */
export interface EquipmentApiApiEquipmentCompanyNameIdCertificateGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EquipmentApiApiEquipmentCompanyNameIdCertificateGet
     */
    readonly companyName: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentApiApiEquipmentCompanyNameIdCertificateGet
     */
    readonly id: string
}

/**
 * Request parameters for apiEquipmentCompanyNameIdGet operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentCompanyNameIdGetRequest
 */
export interface EquipmentApiApiEquipmentCompanyNameIdGetRequest {
    /**
     * The Company Name to use.
     * @type {string}
     * @memberof EquipmentApiApiEquipmentCompanyNameIdGet
     */
    readonly companyName: string

    /**
     * The ID field of the asset. **Note:** Do not confuse with Global ID. This ID is &#x60;GAGES.GAGE_SN&#x60;
     * @type {string}
     * @memberof EquipmentApiApiEquipmentCompanyNameIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiEquipmentCreateMetadataGet operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentCreateMetadataGetRequest
 */
export interface EquipmentApiApiEquipmentCreateMetadataGetRequest {
    /**
     * The name of the template to create metadata from.
     * @type {string}
     * @memberof EquipmentApiApiEquipmentCreateMetadataGet
     */
    readonly templateName?: string
}

/**
 * Request parameters for apiEquipmentGlobalIdCheckOutRecordsGet operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentGlobalIdCheckOutRecordsGetRequest
 */
export interface EquipmentApiApiEquipmentGlobalIdCheckOutRecordsGetRequest {
    /**
     * The Global ID of the equipment.
     * @type {string}
     * @memberof EquipmentApiApiEquipmentGlobalIdCheckOutRecordsGet
     */
    readonly globalId: string

    /**
     * Optional. The Location ID to filter equipment checked out from this location or its sub-locations (at or under).
     * @type {string}
     * @memberof EquipmentApiApiEquipmentGlobalIdCheckOutRecordsGet
     */
    readonly locationId?: string
}

/**
 * Request parameters for apiEquipmentGlobalIdInventoryInformationGet operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentGlobalIdInventoryInformationGetRequest
 */
export interface EquipmentApiApiEquipmentGlobalIdInventoryInformationGetRequest {
    /**
     * The Global ID of an equipment.
     * @type {string}
     * @memberof EquipmentApiApiEquipmentGlobalIdInventoryInformationGet
     */
    readonly globalId: string

    /**
     * The Location ID of an equipment. Optional.
     * @type {string}
     * @memberof EquipmentApiApiEquipmentGlobalIdInventoryInformationGet
     */
    readonly locationId?: string
}

/**
 * Request parameters for apiEquipmentGlobalIdLeaderKitGet operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentGlobalIdLeaderKitGetRequest
 */
export interface EquipmentApiApiEquipmentGlobalIdLeaderKitGetRequest {
    /**
     * The Global ID of an equipment that belongs to a kit.
     * @type {string}
     * @memberof EquipmentApiApiEquipmentGlobalIdLeaderKitGet
     */
    readonly globalId: string
}

/**
 * Request parameters for apiEquipmentGlobalIdTaxonomyTreeGet operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentGlobalIdTaxonomyTreeGetRequest
 */
export interface EquipmentApiApiEquipmentGlobalIdTaxonomyTreeGetRequest {
    /**
     * The ID of the equipment.
     * @type {string}
     * @memberof EquipmentApiApiEquipmentGlobalIdTaxonomyTreeGet
     */
    readonly globalId: string
}

/**
 * Request parameters for apiEquipmentPost operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentPostRequest
 */
export interface EquipmentApiApiEquipmentPostRequest {
    /**
     * The command containing template name and asset information.
     * @type {CreateEquipmentFromTemplateCommand}
     * @memberof EquipmentApiApiEquipmentPost
     */
    readonly createEquipmentFromTemplateCommand?: CreateEquipmentFromTemplateCommand
}

/**
 * Request parameters for apiEquipmentSearchByTaxonomyLocationGet operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentSearchByTaxonomyLocationGetRequest
 */
export interface EquipmentApiApiEquipmentSearchByTaxonomyLocationGetRequest {
    /**
     * The ID of the Taxonomy Node to relate in the search.
     * @type {string}
     * @memberof EquipmentApiApiEquipmentSearchByTaxonomyLocationGet
     */
    readonly taxonomyNodeId?: string

    /**
     * The location tree location ID where the equipment should be.
     * @type {string}
     * @memberof EquipmentApiApiEquipmentSearchByTaxonomyLocationGet
     */
    readonly locationId?: string

    /**
     * The location to pick from in the equipment. (Defaults to Current)
     * @type {LocationStorageType}
     * @memberof EquipmentApiApiEquipmentSearchByTaxonomyLocationGet
     */
    readonly locationType?: LocationStorageType

    /**
     * Excludes unique assets that are already in kits.  Defaults to false.
     * @type {boolean}
     * @memberof EquipmentApiApiEquipmentSearchByTaxonomyLocationGet
     */
    readonly excludeItemsInKits?: boolean

    /**
     * 
     * @type {number}
     * @memberof EquipmentApiApiEquipmentSearchByTaxonomyLocationGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof EquipmentApiApiEquipmentSearchByTaxonomyLocationGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiEquipmentValidateIdForCreationPost operation in EquipmentApi.
 * @export
 * @interface EquipmentApiApiEquipmentValidateIdForCreationPostRequest
 */
export interface EquipmentApiApiEquipmentValidateIdForCreationPostRequest {
    /**
     * 
     * @type {ValidateEquipmentIdForCreationCommand}
     * @memberof EquipmentApiApiEquipmentValidateIdForCreationPost
     */
    readonly validateEquipmentIdForCreationCommand?: ValidateEquipmentIdForCreationCommand
}

/**
 * EquipmentApi - object-oriented interface
 * @export
 * @class EquipmentApi
 * @extends {BaseAPI}
 */
export class EquipmentApi extends BaseAPI implements EquipmentApiInterface {
    /**
     * 
     * @summary Gets the latest calibration certificate blob (stored in Local Database) for an equipment by Company Name and Asset ID.
     * @param {EquipmentApiApiEquipmentCompanyNameIdCertificateDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentCompanyNameIdCertificateDownloadGet(requestParameters: EquipmentApiApiEquipmentCompanyNameIdCertificateDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentCompanyNameIdCertificateDownloadGet(requestParameters.companyName, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the latest calibration certificate metadata for an equipment by Company Name and Asset ID.
     * @param {EquipmentApiApiEquipmentCompanyNameIdCertificateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentCompanyNameIdCertificateGet(requestParameters: EquipmentApiApiEquipmentCompanyNameIdCertificateGetRequest, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentCompanyNameIdCertificateGet(requestParameters.companyName, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets an equipment by Company Name and Asset ID.
     * @param {EquipmentApiApiEquipmentCompanyNameIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentCompanyNameIdGet(requestParameters: EquipmentApiApiEquipmentCompanyNameIdGetRequest, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentCompanyNameIdGet(requestParameters.companyName, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get equipment created metadata.
     * @param {EquipmentApiApiEquipmentCreateMetadataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentCreateMetadataGet(requestParameters: EquipmentApiApiEquipmentCreateMetadataGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentCreateMetadataGet(requestParameters.templateName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all records with quantities that an equipment currently has checked out.  Optionally filters by location to verify if equipment was checked out from a specific location or its sub-locations.
     * @param {EquipmentApiApiEquipmentGlobalIdCheckOutRecordsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentGlobalIdCheckOutRecordsGet(requestParameters: EquipmentApiApiEquipmentGlobalIdCheckOutRecordsGetRequest, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentGlobalIdCheckOutRecordsGet(requestParameters.globalId, requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finds the Unique or Inventory based asset, by its Global ID.  Then also retrieve some inventory/location information, by its Location From.
     * @param {EquipmentApiApiEquipmentGlobalIdInventoryInformationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentGlobalIdInventoryInformationGet(requestParameters: EquipmentApiApiEquipmentGlobalIdInventoryInformationGetRequest, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentGlobalIdInventoryInformationGet(requestParameters.globalId, requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finds the leader kit of an equipment if it belongs to a kit, by its Global ID.
     * @param {EquipmentApiApiEquipmentGlobalIdLeaderKitGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentGlobalIdLeaderKitGet(requestParameters: EquipmentApiApiEquipmentGlobalIdLeaderKitGetRequest, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentGlobalIdLeaderKitGet(requestParameters.globalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the Taxonomy Hierarchy for the Taxonomy Node associated with an Equipment.
     * @param {EquipmentApiApiEquipmentGlobalIdTaxonomyTreeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentGlobalIdTaxonomyTreeGet(requestParameters: EquipmentApiApiEquipmentGlobalIdTaxonomyTreeGetRequest, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentGlobalIdTaxonomyTreeGet(requestParameters.globalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new equipment asset from a template.  Fields marked as template-linked cannot be overridden by the user.  Use the GET /create-metadata endpoint to retrieve field definitions and template links before creating.
     * @param {EquipmentApiApiEquipmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentPost(requestParameters: EquipmentApiApiEquipmentPostRequest = {}, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentPost(requestParameters.createEquipmentFromTemplateCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finds equipment based on a Taxonomy Node ID and optionally a location.
     * @param {EquipmentApiApiEquipmentSearchByTaxonomyLocationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentSearchByTaxonomyLocationGet(requestParameters: EquipmentApiApiEquipmentSearchByTaxonomyLocationGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentSearchByTaxonomyLocationGet(requestParameters.taxonomyNodeId, requestParameters.locationId, requestParameters.locationType, requestParameters.excludeItemsInKits, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checks whether the equipment can be created given a Company Name and Equipment Id.  Follows the business rules for system-wide settings \"Use unique Equipment Ids across all companies\".
     * @param {EquipmentApiApiEquipmentValidateIdForCreationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentApi
     */
    public apiEquipmentValidateIdForCreationPost(requestParameters: EquipmentApiApiEquipmentValidateIdForCreationPostRequest = {}, options?: RawAxiosRequestConfig) {
        return EquipmentApiFp(this.configuration).apiEquipmentValidateIdForCreationPost(requestParameters.validateEquipmentIdForCreationCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

